export const convertSnakeCaseStringToCapitalize = (string) => {
  if (typeof string === 'string') {
    const correctStringFormat = string.replace(/_/gi, ' ');
    return (
      correctStringFormat.charAt(0).toUpperCase() + correctStringFormat.slice(1).toLowerCase()
    );
  }
  return null;
};
